@if (project) {
  <app-detail-view [data]="project" [headerTemplate]="projectHeaderTemplate" (closeClicked)="onCloseButtonClicked()">
    <a class="text-xl font-bold" [href]="getCustomerLink()"
      >{{ project.customerName }}
      <fa-icon [icon]="faLink"></fa-icon>
    </a>
    <div class="flex w-full gap-4">
      @if (isAdmin) {
        <div class="flex flex-1 flex-col items-start gap-1">
          <div>{{ 'hours' | translate }}</div>
          <div>{{ project.sumHours | number: '1.0-2' }}</div>
        </div>
      }
      <a class="flex flex-1 flex-col items-start gap-1" [href]="getTeamLink()">
        <div>
          {{ 'employee.numberOf' | translate }}
          <fa-icon [icon]="faLink"></fa-icon>
        </div>
        <div>{{ project.projectParticipants.length }}</div>
      </a>
    </div>
    <gx-tabs>
      <gx-tab [caption]="'employee.plural' | translate" id="employees">
        <app-details-employee-list [project]="project"></app-details-employee-list>
      </gx-tab>
      <gx-tab [caption]="'project.factSheet.singular' | translate" id="factsheet">
        @if (factSheet) {
          <app-project-factsheet [factSheet]="factSheet"></app-project-factsheet>
        } @else {
          <app-no-factsheet />
        }
      </gx-tab>
    </gx-tabs>

    <ng-template #projectHeaderTemplate let-data="data">
      <div class="text-xl font-bold">{{ data.name }} ({{ data.id }})</div>
    </ng-template>
  </app-detail-view>
}
